import { __extends } from "tslib";
import { Backend } from './base';
var TtBackend = /** @class */ (function (_super) {
    __extends(TtBackend, _super);
    function TtBackend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sdk = tt;
        return _this;
    }
    TtBackend.prototype.normalizeEnvInfo = function (systemInfo, networkStatus) {
        return {
            host_platform: 'tt',
            host_app_name: systemInfo.appName,
            host_app_version: systemInfo.version,
            platform: systemInfo.platform,
            sdk_version: systemInfo.SDKVersion,
            os_name: systemInfo.platform,
            os_version: systemInfo.system,
            device_brand: systemInfo.brand,
            device_model: systemInfo.model,
            screen_width: systemInfo.screenWidth,
            screen_height: systemInfo.screenHeight,
            resolution: systemInfo.screenWidth + 'x' + systemInfo.screenHeight,
            pixel_ratio: systemInfo.pixelRatio,
            network_type: networkStatus.networkType,
        };
    };
    return TtBackend;
}(Backend));
export default TtBackend;
//# sourceMappingURL=tt.js.map